import { departmentDashboard } from '../../actions/constant';

const {
  UPDATE_DEPARTMENT_PTO_FAILURE,
  UPDATE_DEPARTMENT_PTO_SUCCESS,
  RESET_UPDATE_DEPARTMENT_PTO,
  UPDATE_DEPARTMENT_PTO_LOADER,
} = departmentDashboard;

const intitialstate: object = {
  response: null,
  isRequestApproved: false,
  loader: false,
};

export const updateDepartmentPTORequestReuder = (state = intitialstate, action: any) => {
  switch (action.type) {
    case UPDATE_DEPARTMENT_PTO_SUCCESS: {
      return {
        ...state,
        isRequestApproved: true,
        response: action.payload,
        loader: false,
      };
    }

    case UPDATE_DEPARTMENT_PTO_FAILURE:
      return {
        ...state,
        isRequestApproved: false,
        response: action.payload,
        loader: false,
      };

    case UPDATE_DEPARTMENT_PTO_LOADER:
      return {
        ...state,
        loader: true,
      };

    case RESET_UPDATE_DEPARTMENT_PTO:
      return intitialstate;

    default:
      return state;
  }
};
